import { useEffect, useRef } from "react";
import { useScroll, useTransform, useSpring } from "framer-motion";
import { useMediaQuery } from "./useMediaQuery";

export const useHeroMotion = () => {
  const ref = useRef(null);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const yBack = useTransform(scrollYProgress, [0, 1], [0, 180]);
  const yFront = useTransform(scrollYProgress, [0, 1], [0, -120]);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  const mx = useSpring(0, { stiffness: 60, damping: 20 });
  const my = useSpring(0, { stiffness: 60, damping: 20 });

  useEffect(() => {
    if (isMobile || reducedMotion) {
      mx.jump(0);
      my.jump(0);
      return;
    }
    const onMove = (event) => {
      mx.set((event.clientX / window.innerWidth - 0.5) * 40);
      my.set((event.clientY / window.innerHeight - 0.5) * 40);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, [isMobile, reducedMotion, mx, my]);

  return { ref, isMobile, mx, my, yBack: reducedMotion ? 0 : yBack,
    yFront: reducedMotion ? 0 : yFront, opacity: reducedMotion ? 1 : opacity };
};